module.exports = __webpack_public_path__ + "img/img_nav_bet_hover.d4165142.svg";